import React from "react";
import PATHS from "config/paths";

/* eslint-disable react-hooks/exhaustive-deps */

const cache = new Map();

export function useGetVictimsCsv(token, search, shouldDownload) {
  const [error, setError] = React.useState();
  const [isLoading, setIsLoading] = React.useState(false);
  const [isCompleted, setIsCompleted] = React.useState(false);

  React.useEffect(() => {

    if(token && search && shouldDownload) {
      setIsLoading(true);
      setError(undefined);

      // Add page to pages
      const headers = new Headers();
      headers.append("Accept", "text/csv");
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Origin", "{location.protocol + '//' + location.host}");
      const options = {
        method: "GET",
        headers: headers,
        redirect: "follow",
        cache: "no-cache",
      };

      /**
       * Filters
       */
      let filters = "";
      if (filters.length > 0 && search?.length > 0) {
        filters = `${filters}&${search}`;
      } else if (search?.length > 0) {
        filters = search;
      }

      /**
       * Make request
       */
      fetch(`${PATHS.apiVictims}/search_to_csv?${filters}`, options)               
        .then((response) => response.blob())
        .then((blob) => {
            // Use the response blob as-is so encoding bytes (BOM) are preserved.
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `victims-${(new Date().toJSON().slice(0,10))}.csv`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
            setIsCompleted(true);
          })
          .catch((error) => setError(error))
          .finally(() => {
            setIsLoading(false)
            
          });
    }
  }, [token, search, shouldDownload]);

  return { isCompleted, downloadError: error, isLoading };
}
